"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class Event {
  constructor() {
    this.listeners = [];
  }
  on = callback => {
    this.listeners.push(callback);
  };
  off = callback => {
    const index = this.listeners.indexOf(callback);
    if (index >= 0) {
      this.listeners.splice(index, 1);
    }
  };
  fire = data => {
    this.listeners.forEach(listener => {
      if (typeof listener === 'function') {
        listener(data);
      }
    });
  };
}
exports.default = Event;
//# sourceMappingURL=event.js.map